<template>
  <section id="settings-taghandle" class="bd-index-fullscreen hero is-fullheight">
    <div class="hero-head">
      <nav class="level">
        <div class="level-left">
          <div class="level-item has-padding-top has-padding-x">
            <a @click="$router.go(-1)" class="button is-dark has-text-primary is-outlined">
              <b-icon pack="fas" icon="chevron-left"></b-icon>
            </a>
            <!--<a @click="logout">Logout</a>-->
          </div>
        </div>

        <div class="level-right">
          <div class="level-item has-padding-top has-padding-x">
            <a @click="$router.go(-1)" class="button is-dark has-text-primary is-outlined">
              <b-icon pack="fas" icon="times"></b-icon>
              <!--<font-awesome-icon icon="sign-out"></font-awesome-icon>-->
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="hero-body">
      <div class="container" style="margin: 0 auto; position: relative;" >
        <!--<div class="box bg-grey-dark box-shadow-dark">-->

        <div class="columns">
          <div class="column is-offset-3 is-6">
            <div class="card-content">
              <div class="content">
                <h3>User Name</h3>
                <h1 v-if="userProfile.name">{{userProfile.name.title}}</h1>
                <p v-else>Error - You have been logged off.....</p>
                <form @submit.prevent>
                  <div class="columns">
                    <div class="column">
                      <b-input v-model.trim="userProfile.taghandle" :value="userProfile.taghandle" maxlength="20" id="taghandle" expanded></b-input>
                      <transition name="fade">
                        <b-notification v-if="showError"
                          type="is-danger"
                          aria-close-label="Close notification"
                          role="alert">
                          Oh no, Looks like it's already taken 😢
                        </b-notification>
                      </transition>
                      <transition name="fade">
                        <b-message title="It's Yours!" v-if="showSuccess" type="is-success" aria-close-label="Close message">
                          It's available - you can start using your Tag Handle:
                          <a href="">@{{ userProfile.taghandle }}</a> | <a href=""><span class="is-dark">osla.io/</span>{{ userProfile.taghandle }}</a>
                        </b-message>
                        <!--
                        <b-notification v-if="showSuccess"
                          type="is-success"
                          aria-close-label="Close notification"
                          role="alert">
                          It's free - your tag handle is now @{{ userProfile.taghandle }} and your urls is <span class="is-dark">osla.io/</span>{{ userProfile.taghandle }}
                        </b-notification>-->
                      </transition>
                      <!--
                      <p><span class="is-dark">osla.io/</span>{{ userProfile.taghandle }}</p>
                      -->
                      <p>A User Name is Required.</p>
                      <p><small><i>Your UserName will be become your URL (link) and Tag Handle allowing users to connect to your account.</i></small></p>
                    </div>
                  </div>
                  <b-button @click="checkProfileTagHandle" class="is-fullwidth" type="is-primary">Claim User Name</b-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-foot">
      <div class="container">
        <div class="tabs is-centered">
          <ul>
            <li>
              <a>
                <img src="@/assets/logo.png" alt="Osla" width="70px">
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      taghandle: "",
      showSuccess: false,
      showError: false,

    };
  },
  computed: {
    ...mapState(["userProfile"])
  },
  methods: {
    checkProfileTagHandle() {
      this.$store.dispatch("checkProfileTagHandle", {
        taghandle: this.taghandle !== "" ? this.taghandle : this.userProfile.taghandle,
      }).then(response => {
        if (response.empty) {
          console.log("Response User Name Free! " + response)
          this.updateProfileTagHandle();
        } else {
          console.log("Response User Name Exists! " + response)
          this.showError = true;
          this.showSuccess = false;
        }
      }, error => {
        console.error("Server Error." + response)
      })
    },
    updateProfileTagHandle() {
      this.$store.dispatch("updateProfileTagHandle", {
        taghandle: this.taghandle !== "" ? this.taghandle : this.userProfile.taghandle,
      }).then(response => {
        console.log("Got some data! " + response)
        this.showSuccess = true;
        this.showError = false;
      }, error => {
        console.error("Got nothing from server." + response)
        this.showError = true;
        this.showError = false;
      })
      
      /*
      setTimeout(() => {
        this.showSuccess = false;
        this.showError = false;
      }, 2000);
      */
    },
  }
};
</script>
